<div class="auftrag-lieferung-komponente">
  <div class="section ion-activatable" appClick (clicked)="onLieferungClicked($event)" [class.section-invalid]="!(auftragdetails.istLieferungVollstaendig | async)">
    <h1>{{ getEinstellung('Titel', 'Lieferung') }} <span *ngIf="!(auftragdetails.istLieferungVollstaendig | async)" class="nicht-vollstaendig">{{ 'BitteEingabePruefen' | translate }}</span></h1>
    <div class="lieferung-liste">
      <app-lieferung #appLieferung
                     [auftragdetails]="auftragdetails"
                     [auftrag]="auftrag"
                     [formularkonfiguration]="lieferungFormularkonfiguration"
                     [isPositionenEinzelnBearbeiten]="isPositionenEinzelnBearbeiten"></app-lieferung>
    </div>

    <div *ngIf="isArtikelHinzufuegenButtonAnzeigen && !auftragdetails.isLieferungAendernGesperrt" class="mt-15">
      <ion-button appClick (clicked)="onPositionHinzufuegen()" class="button-md button-border" color="light">Hinzufügen</ion-button>
    </div>
  </div>
</div>